import Cast from "../components/cast";
import CastingDetails from "../components/castingDetails";

const RouterData = [
    {
      path: "",
      element: <Cast />,
      title: "Cast"
    },  
    {
      path: "/:castId",
      element: <CastingDetails />,
      title: "Cast Details"
    },  
  ];
  
  export default RouterData;